<template>
  <div
    class="modal fade"
    tabIndex="-1"
    data-bs-backdrop="static"
    ref="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("settings.delete") }}</h5>
        </div>

        <div class="modal-body">
          {{ $t("settings.delete_message", {name: toolName}) }}
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="hide"
          >
            {{ $t("settings.close") }}
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="color: white"
            @click="confirmDelete"
          >
            {{ $t("settings.delete") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Modal} from "@comlinedev/bootstrap5";

  export default {
    name: "ToolDeleteModal",
    props: {
      toolName: {
        type: String,
        default: "",
      },
    },
    emits: ["confirm"],
    data() {
      return {
        modalInstance: null,
      };
    },
    methods: {
      show() {
        this.modalInstance?.show();
      },
      hide() {
        this.modalInstance?.hide();
      },
      confirmDelete() {
        this.$emit("confirm");
        this.hide();
      },
    },
    mounted() {
      this.modalInstance = new Modal(this.$refs.modal);
    },
  };
</script>
